export const Container: React.FC<{ children: any }> = ({ children }) => (
  <div className='container mx-auto'>{children}</div>
);

export default Container;
